var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import { Close } from '../shapes/hamburger';
import { granite } from '../colors';
import { deprecatedProp as deprecated } from '../utils';
import BlockButton from '../Utilities/BlockButton';
export default class Modal extends React.Component {
    render() {
        const _a = this.props, { title, closeButton, footer, size, bsSize, onRequestHide, closeOnOutsideClick, style, className, bsStyle, status, wrapperStyle } = _a, rest = __rest(_a, ["title", "closeButton", "footer", "size", "bsSize", "onRequestHide", "closeOnOutsideClick", "style", "className", "bsStyle", "status", "wrapperStyle"]);
        let modalClassName = 'modal-dialog';
        if (size || bsSize) {
            modalClassName += ` modal-${size || bsSize}`;
        }
        if (className) {
            modalClassName += ' ' + className;
        }
        let modalBodyClassName = 'modal-content';
        if (status || bsStyle) {
            modalBodyClassName += ` modal-${status || bsStyle}`;
        }
        const ModalHeader = (React.createElement("div", { className: "modal-header" },
            React.createElement("div", { className: "modal-title" }, title),
            closeButton ? (React.createElement("button", { className: "close", onClick: onRequestHide },
                React.createElement(Close, { width: "16px", color: granite.base, cropped: true }))) : null));
        const ModalFooter = footer && React.createElement("div", { className: "modal-footer" }, footer);
        const modalNode = (React.createElement(BlockButton, { onClick: e => e.stopPropagation(), onKeyDown: e => e.stopPropagation(), className: "modal", style: Object.assign({ display: 'block', paddingLeft: '0px' }, wrapperStyle), tabIndex: "-1" },
            React.createElement("div", { className: modalClassName, style: Object.assign({ zIndex: '1050' }, style) },
                React.createElement("div", Object.assign({ className: modalBodyClassName }, rest),
                    ModalHeader,
                    React.createElement("div", { className: "modal-body" }, this.props.children),
                    ModalFooter)),
            React.createElement(BlockButton, { tabIndex: '-1', className: "modal-backdrop fade in", onClick: closeOnOutsideClick ? onRequestHide : null })));
        return ReactDOM.createPortal(modalNode, document.body);
    }
}
export const modalDefaultProps = { closeOnOutsideClick: false };
export const modalPropTypes = {
    title: PropTypes.node,
    className: PropTypes.string,
    style: StylePropType,
    wrapperStyle: StylePropType,
    footer: PropTypes.node,
    onRequestHide: PropTypes.func,
    closeOnOutsideClick: PropTypes.bool,
    closeButton: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'lg']),
    bsSize: deprecated(PropTypes.oneOf(['sm', 'lg']), 'Use `size` instead.'),
    status: PropTypes.oneOf(['warning', 'error', 'danger', 'success', 'info']),
    children: PropTypes.node,
    bsStyle: deprecated(PropTypes.oneOf(['warning', 'error', 'danger', 'success', 'info']), 'Use `status` instead.'),
};
Modal.defaultProps = modalDefaultProps;
Modal.propTypes = modalPropTypes;
